var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-view-main-menu",class:{
    'c-view-main-menu-on-settings': _vm.settingsVisible,
    'c-view-main-menu-on-main': !_vm.settingsVisible
  }},[_c('div',{staticClass:"c-view-main-menu-content"},[_c('img',{staticClass:"c-view-main-menu-logo",attrs:{"src":"/bitmaps/game-logo.png","alt":"Full Spectrum Warrior Go","title":"Full Spectrum Warrior Go"}}),(_vm.settingsVisible)?_c('settings',{staticClass:"c-view-main-menu-settings",on:{"back":_vm.toggleSettings}}):_c('div',{staticClass:"c-view-main-menu-items"},[(_vm.$store.getters.completedLevelIds && (_vm.$store.getters.currentLevelId || _vm.$store.getters.nextLevelId))?_c('router-link',{staticClass:"c-view-main-menu-item",attrs:{"to":{
          name: 'level',
          params: {
            levelId: _vm.$store.getters.currentLevelId || _vm.$store.getters.nextLevelId
          }
        }}},[_vm._v(" Continue campaign ")]):_vm._e(),_vm._l((_vm.mapLinks),function(ref){
        var name = ref.name;
        var id = ref.id;
return _c('router-link',{key:id,staticClass:"c-view-main-menu-item",attrs:{"to":{
          name: 'level',
          params: {
            levelId: id
          }
        }}},[_c('strong',[(_vm.levelIsCompleted(id))?[_vm._v(" ✅ ")]:_vm._e(),_vm._v(" "+_vm._s(name)+" ")],2)])}),_c('button',{staticClass:"c-view-main-menu-item",on:{"click":_vm.toggleSettings}},[_vm._v(" Settings ")]),_c('router-link',{staticClass:"c-view-main-menu-item",attrs:{"to":{
          name: 'debug'
        }}},[_vm._v(" Debug ")])],2)],1),_c('img',{staticClass:"c-view-main-menu-image",attrs:{"src":"/bitmaps/splash-screen.jpg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }